// Translation file for MintatantervFejlesztesek component
// Contains all UI text in Hungarian and English

export const MINTATANTERVFEJLESZTESEK_TRANSLATIONS = {
    hu: {
        pageTitle: "6. Mintatanterv fejlesztések, módosítások",
        
        section1: {
            title: "6.1. Kérjük, mutassa be, hogy a vizsgált időszakban milyen fejlesztések, módosítások valósultak meg a szak mintatervében",
            subtitle: "Tananyag- és esettanulmány-fejlesztések (AACSB Std 4). Kérjük megjelölni, milyen fejlesztések történtek",
            noteLabel: "Megjegyzés (opcionális):",
        },
        
        section2: {
            title: "6.2. Tantárgyi koherencia értékelése",
            description: "Kérjük jelölje meg, hogyan ítéli meg a szak tantárgyainak összehangoltságát, a tanulási útvonal logikáját és koherenciáját",
            subtitle: "A szak tantárgyi koherenciája az adott félévben",
        },
        
        section3: {
            title: "6.3. Azonosított problématípusok (több válasz jelölhető)",
            noteLabel: "Megjegyzés (opcionális):",
        },

        section4: {
            title: "6.4. Tananyagok nyelvi megfelelősége (magyar / angol) és képzési formák közötti összhang",
            description: "Kérjük értékelni, hogy a szak tananyagai mennyire összehangoltak nyelvi és képzési forma szerinti bontásban",
            subtitle: "Magyar és angol nyelvű tananyagok összehangoltsága",
        },
        
        buttons: {
            previous: "Előző szakasz",
            next: "Következő szakasz",
            save: "Mentés",
            finalize: "Véglegesítés",
            unfinalize: "Véglegesítés visszavonása"
        },
        
        alerts: {
            requiredFields: "Minden szöveges mezőt ki kell tölteni!"
        },
        
        modal: {
            imageAlt: "Nagyított kép",
            closeButton: "Bezárás"
        },
        
        sidebar: [
            "Szak alapadatok",
            "A képzés",
            "A szak mintatanterve",
            "Tehetséges, kiemelkedő hallgatói teljesítmények",
            "Idegen nyelvi követelmények",
            "Kötelező szakmai gyakorlat",
            "Mintatanterv fejlesztések, módosítások",
            "Fejlesztési javaslatok",
            "Oktatás",
            "A szak hallgatóira vonatkozó adatok",
            "Versenytárs elemzés",
            "Meghívott előadók és óraadók",
            "Oktatók értékelése",
            "A képzés tanulmányi körülményei",
            "A szak kommunikációja",
            "Fejlesztési javaslatok megvalósítása és értékelése",
            "Szakjelentés lezárása"
        ]
    },
    
    en: {
        pageTitle: "6. Curriculum Developments and Revisions",
        
        section1: {
            title: "6.1. Developments and Revisions to the Sample Curriculum",
            description: "Please describe the developments and revisions implemented in the programme’s sample curriculum during the review period",
            subtitle: "Teaching material and case study developments (AACSB Standard 4). Please indicate the developments implemented",
            noteLabel: "Comments (optional):",
        },
        
        section2: {
            title: "6.2. Evaluation of Course Coherence",
            description: "Please indicate how you assess the alignment of courses within the programme, as well as the logic and coherence of the learning pathway",
            subtitle: "Course coherence of the programme in the given semester",
        },
        
        section3: {
            title: "6.3. Identified Types of Issues (multiple answers may be selected)",
            noteLabel: "Comments (optional):",
        },

        section4: {
            title: "6.4. Linguistic Alignment of Teaching Materials (Hungarian / English) and Consistency Across Modes of Delivery",
            description: ". \n Please evaluate the extent to which the programme’s teaching materials are aligned by language and mode of delivery",
            subtitle: "Alignment of Hungarian- and English-language teaching materials",
        },
        
        buttons: {
            previous: "Previous Section",
            next: "Next Section",
            save: "Save",
            finalize: "Finalize",
            unfinalize: "Withdraw Finalization"
        },
        
        alerts: {
            requiredFields: "All text fields must be filled!"
        },
        
        modal: {
            imageAlt: "Enlarged image",
            closeButton: "Close"
        },
        
        sidebar: [
            "Programme Basic Data",
            "The Programme",
            "Programme Curriculum",
            "Talented Students and Outstanding Student Performance",
            "Foreign Language Requirements",
            "Compulsory Professional Practice",
            "Curriculum Developments and Modifications",
            "Development Recommendations",
            "Teaching",
            "Data related to the major",
            "Competitor Analysis",
            "Guest Lecturers and Part-time Teachers",
            "Assessment of Teachers",
            "Study Conditions",
            "Programme Communication",
            "Implementation and Evaluation of Development Recommendations",
            "Finalisation of Programme Report"
        ]
    }
};
